import {Info, Trash2} from "feather-icons-react/build/IconComponents";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Table from "../../core/pagination/datatable";
import { GetRequest } from "../../functions/ApiFunctions";
import { tableColumn } from "../constants/tableColumn";
import { OverlayTrigger,Tooltip } from "react-bootstrap";
import { DataSourceSearch } from "../../functions/HandleSearch";


const ListSubscriptions = () => {
  const [dataSource,setDataSource] = useState(null)
  const [Search, setSearch] = useState("");

  const fetchData = async () => {
    const res = await GetRequest("subscription")
    if (res){
      setDataSource(res)
    }
  }
  useEffect(()=>{
    fetchData()
  },[])

// groupId

  const columns = [
    {
      title: "Action",
      dataIndex: "action",
      render: (_,record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            

            {/* <OverlayTrigger placement="top" overlay={
              <Tooltip id="printer-tooltip">
                <div>
                  <p>{record?.selfieId ? "Selfie Is Added" : "Selfie Not Added"}</p>
                  <p>{record?.emailVerified ? "Email Is Verified" : "Email Is Not Verified"}</p>
                  {record?.createdAt && (<p>Joined at {new Date(record?.createdAt).toLocaleDateString()}</p>) }
                </div>
              </Tooltip>}>
              <Link className="me-2 p-2" >
                <Info className="feather-edit" style={{color :  record?.selfieId && record?.emailVerified ? "green" : "red"}}/>
              </Link>
            </OverlayTrigger> */}
            
            {/* <Link
              className="confirm-text p-2"
              to="#"
              onClick={showConfirmationAlert}
            >
              <Trash2 className="feather-trash-2" />
            </Link> */}
          </div>
        </div>
      ),
      sorter: (a, b) => a.createdby.length - b.createdby.length,
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>User List</h4>
              <h6>Manage your Users</h6>
            </div>
          </div>

          {/* <div className="page-btn">
            <Link to={route.addproduct} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Add New Product
            </Link>
          </div> */}
        </div>
        {/* /product list */}
        <div className="card ">
          <div className="card-body">
            {/*<div className="table-top">
               <div className="search-set">
                <div className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={Search}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                  <button className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </button>
                </div>
              </div> 

            </div>*/}
            <div className="table-responsive">
              <Table columns={tableColumn.subscription} dataSource={dataSource}  />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ListSubscriptions;